import { LoyaltyBadge } from './LoyaltyBadge.jsx';

// Past this many slots the sheet stops being readable at a glance and starts wrapping
// into a wall of circles, so it collapses to a single badge with a count instead.
const MAX_DRAWN_SLOTS = 12;

/**
 * A member's stamp sheet for one category: as many slots as the sheet holds, the earned
 * ones carrying the stamp's image or emoji and the rest left as dashed outlines, so it
 * reads as "three of five, two to go" rather than a bare number.
 *
 * A sheet with no cap has no slots to draw — there is no "out of" to show — so it falls
 * back to the count, same as an oversized one.
 */
export function LoyaltyStampSheet({ category, count }) {
  const earned = count || 0;
  const sheetSize = category.max_stamps || 0;
  const drawSlots = sheetSize > 0 && sheetSize <= MAX_DRAWN_SLOTS;

  return (
    <div className="flex flex-col items-center gap-2">
      {drawSlots ? (
        <div className="flex flex-row flex-wrap justify-center gap-2 max-w-[320px]">
          {Array.from({ length: sheetSize }, (_, index) => (
            index < earned ? (
              <LoyaltyBadge
                key={index}
                image={category.image_url}
                emoji={category.emoji}
                name={category.name}
                size={48}
              />
            ) : (
              <div
                key={index}
                className="rounded-full border-[2px] border-dashed border-[#C9C9C9] shrink-0"
                style={{ width: 48, height: 48 }}
              />
            )
          ))}
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <LoyaltyBadge image={category.image_url} emoji={category.emoji} name={category.name} size={48} />
          <span className="secondary-font-bold fs-20 lh-22">
            x {earned}
            {sheetSize ? <span className="text-(--color-text-subtle)"> / {sheetSize}</span> : null}
          </span>
        </div>
      )}

      <span className="fs-14 lh-16 text-center">
        {category.name}
        {drawSlots && (
          <span className="text-(--color-text-subtle)"> · {earned} de {sheetSize}</span>
        )}
      </span>
    </div>
  );
}
